import type { PageGroup } from '@st/sdk'

/** Persisted groups use their event-assigned identity. Only legacy navigation and
 * unsaved gap rows use their range, until an edit creates their persisted identity.
 */
export function pageGroupKey(group: PageGroup): string {
  return group.id ?? `${group.pageRange.first}-${group.pageRange.last}`
}
